import { ThunkAction, ThunkDispatch } from 'redux-thunk'

import Client from '../Client/Client'

import {
  ADD_MARK,
  DELETE_MARK,
  GET_SKIN_TRACK_FAILURE,
  GET_SKIN_TRACK_REQUEST,
  GET_SKIN_TRACK_SUCCESS,
  MOVE_MARK,
  REQUEST_START,
  SET_NOTE,
} from './ActionTypes'
import IState from './IState'
import { Limb } from '../Limb'
import { ISkinTrack } from '../ISkinTrack'

export const getSkinTrack = (
  customerUuid: string,
  limb: Limb,
): ThunkAction<any, any, any, any> => {
  return async (dispatch: ThunkDispatch<IState, undefined, any>) => {
    dispatch({ type: GET_SKIN_TRACK_REQUEST })

    try {
      const skinTrack = await Client.getSkinTrack(customerUuid, limb)
      dispatch(getSkinTrackSuccess(skinTrack, customerUuid, limb))

      return skinTrack
    } catch (e) {
      dispatch({ type: GET_SKIN_TRACK_FAILURE })
    }
  }
}

const getSkinTrackSuccess = (
  skinTrack: ISkinTrack,
  customerUuid: string,
  limb: Limb,
) => {
  return {
    type: GET_SKIN_TRACK_SUCCESS,
    payload: {
      skinTrack,
      customerUuid,
      limb,
    },
  }
}

export const addMark = (
  skinTrackUuid: string,
  customerUuid: string,
  markId: number,
  left: number,
  top: number,
  color: string,
) => {
  Client.addMark(skinTrackUuid, customerUuid, markId, left, top, color)

  return {
    type: ADD_MARK,
    payload: {
      skinTrackId: skinTrackUuid,
      markId,
      left,
      top,
      color,
    },
  }
}

export const moveMark = (
  skinTrackUuid: string,
  customerUuid: string,
  markId: number,
  left: number,
  top: number,
) => {
  Client.moveMark(skinTrackUuid, customerUuid, markId, left, top)

  return {
    type: MOVE_MARK,
    payload: {
      skinTrackId: skinTrackUuid,
      markId,
      left,
      top,
    },
  }
}

export const deleteMark = (
  skinTrackUuid: string,
  customerUuid: string,
  markId: number,
) => {
  Client.deleteMark(skinTrackUuid, customerUuid, markId)

  return {
    type: DELETE_MARK,
    payload: {
      skinTrackId: skinTrackUuid,
      markId,
    },
  }
}

export const setNote = (
  skinTrackUuid: string,
  customerUuid: string,
  newNote: string,
) => {
  Client.setNote(skinTrackUuid, customerUuid, newNote)

  return {
    type: SET_NOTE,
    payload: {
      skinTrackId: skinTrackUuid,
      note: newNote,
    },
  }
}
